import request from '@/utils/request'
let baseURL = '/pay-api';

// 个人现金钱包详情（查询余额）------------------------------>> 更换接口 getCashWallet
// export function myWallet(userOpenId) {
//   return request({
//     url: `/cash/v1/getWallet/${userOpenId}`,
//     method: 'get',
//     baseURL
//   })
// }
/*
* userOpenId: 用户openId
* */

// 现金钱包详情(区分个人钱包和店铺钱包)
export function getCashWallet(data) {
  return request({
    url: `/cash/v1/getCashWallet`,
    method: 'post',
    baseURL,
    data
  })
}
/*
{userOpenid: this.userOpenid, walletType:0}

{
userOpenid (string): 用户openid，包括普通用户openid及店铺shopid ,
walletType (integer): 钱包类型，0：个人钱包，1：店铺钱包
}
* */



// 设置钱包支付密码
export function setPayPassword(data) {
  return request({
    url: '/cash/v1/wallet/setPayPassword',
    method: 'post',
    baseURL,
    data
  })
}
/*
chekPassword (string): 校对密码 ,
password (string): 密码 ,
userOpenId (string): 用户/店铺openId ,
walletType (integer): 钱包类型，0：个人钱包，1：店铺钱包 ++++++++++++++
}
* */


// 修改钱包支付密码
export function resetPayPassword(data) {
  return request({
    url: '/cash/v1/wallet/resetPayPassword',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
chekPassword (string): 校对密码 ,
oldPassword (string): 旧密码 ,
password (string): 密码 ,
userOpenId (string): 用户/店铺openId ,
walletType (integer): 钱包类型，0：个人钱包，1：店铺钱包 +++++++++++
}
* */



// 找回钱包支付密码
export function findBackPayPassword(data) {
  return request({
    url: '/cash/v1/wallet/findBackPayPassword',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
chekPassword (string): 校对密码 ,
password (string): 密码 ,
smsCode (string): 短信验证码 ,
userOpenId (string): 用户/店铺openId ,
walletType (integer): 钱包类型，0：个人钱包，1：店铺钱包 +++++++++++++++
}
* */



// 现金交易记录（分页）
export function cashBalanceRecord(data) {
  return request({
    url: '/cash/v1/cashBalanceRecord',
    method: 'post',
    baseURL,
    data
  })
}
/*

 {
direction (integer, optional): 交易方向，0：收入，1：支出，null：全部 ,
page (integer, optional): 页码 ,
size (integer, optional): 每页大小 ,
type (integer): 交易类型，0：全部 1：充值 2：转帐 3：奖励 4：红包 5：提现；6：余额支付；7：购买商品 ,
userOpenId (string): 用户openId ,
walletType (integer, optional): 钱包类型，0：个人钱包，1：店铺钱包 +++++++++++++++++++
}
* */



// 现金充值 (生成订单)
export function cashRecharge(data) {
  return request({
    url: '/recharge/v1/cashRecharge',
    method: 'post',
    baseURL,
    data,
  })
}
/*
{
amount (string): 购买数量 ,
ip (string, optional): 客户端IP ,
money (string): 支付金额 ,
payType (string): 付款方式，wxPay：微信，aliPay：支付宝 ,wxJSAPI：微信sdk支付
userOpenId (string): 用户openId ,
walletAccount (string): 钱包帐号 ,
wapName (string, optional): WAP 网站名 ,
wapType (string, optional): 微信H5场景类型 ,
wapUrl (string, optional): WAP网站URL地址
}
* */


// 银行卡列表
export function bankList(data) {
  return request({
    url: '/bank/v1/list/',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
bankName (string): 银行名称 ,
bankNumber (string): 卡号 ,
cardholder (string): 持卡人 ,
openid (string): openid
}
* */


// 银行卡归属查询及校验
export function bankCheck(data) {
  return request({
    url: '/bank/v1/check',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
bankCard (string): 卡号
}
* */

// 绑定银行卡
export function bankBind(data) {
  return request({
    url: '/bank/v1/bind',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
openid (string): userId
}
* */



// 1.3.3 现金提现
export function applyForWithdrawal(data) {
  return request({
    url: '/withdrawal/v2/applyFor',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
bankName (string, optional),
cardNumber (string): 银行卡号 ,
fromUserOpenId (string): 付款用户openId，平台的ID为0000000 ,
fromWalletType (integer): 转出钱包类型，0：个人钱包，1：店铺钱包,2：服务商 ,
money (string): 转帐金额 ,
payPassword (string): 支付密码 ,
remarks (string, optional): 备注信息
}
* */


// 查询是否有 服务钱包
export function serviceWallet(data) {
  return request({
    url: '/cash/v1/check/serviceWallet',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
userOpenid (string): 用户openid，包括普通用户openid及店铺shopid ,
walletType (integer): 钱包类型，0：个人钱包，1：店铺钱包 2：服务商
}
* */